import React from 'react';

import { Tooltip } from 'antd';

import { useUserPermission } from '@contexts/UserContext';

import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { Actions } from './ReceivableStyles';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * ReceivableActions
 *
 * Action bar for receivable statements
 * Shows selected rows count, invoice creation and add-to-invoice buttons
 */
const ReceivableActions = ({
    selectedList,
    disableInvoiceButton,
    invoiceButtonErrors,
    selectedStatementsTotal,
    handleCreateInvoice,
    handleAddToInvoice,
}) => {
    const accessAccounting = useUserPermission('AccessAccounting');

    const TooltipContent = () => {
        return (
            <div>
                <p>You can't create an invoice:</p>
                <ul>
                    {invoiceButtonErrors.map((err, index) => (
                        <li key={index}>{err}</li>
                    ))}
                </ul>
            </div>
        );
    };

    return (
        <Actions>
            {`${selectedList.length} rows selected`}
            <div className="statement-action-wrapper">
                <NwButton
                    primary
                    icon={byPrefixAndName.fasl['file-invoice-dollar']}
                    disabled={!selectedList || selectedList.length === 0 || disableInvoiceButton}
                    solid
                    size="small"
                    label={`create invoice${selectedStatementsTotal ? `: ${selectedStatementsTotal}` : ''}`}
                    onClick={handleCreateInvoice}
                />
                {accessAccounting && (
                    <NwButton
                        primary
                        icon={byPrefixAndName.fasl['file-circle-plus']}
                        disabled={!selectedList || selectedList.length === 0 || disableInvoiceButton}
                        solid
                        size="small"
                        label="add to existing invoice draft"
                        onClick={handleAddToInvoice}
                    />
                )}
                {invoiceButtonErrors.length > 0 && (
                    <Tooltip placement="right" title={<TooltipContent />}>
                        <NwIcon danger icon={byPrefixAndName.fasl['exclamation-triangle']} />
                    </Tooltip>
                )}
            </div>
            <span>&nbsp;</span>
        </Actions>
    );
};

export default ReceivableActions;
